import { useCallback } from "react";
import { Flex } from "@chakra-ui/react";

import { useStakeProvider } from "dapp-sdk";

// Components
import { CustomButton as Button, CustomBadge as Badge } from "./Custom";

import {
  DefiItemActionButtonType,
  DefiItemActionData,
} from "@customtypes/global";
import { CLICK_DEFI_PARTNER_LINK } from "@constants/analytics";

import { trackEvent } from "@utils/firebase";

type Props = {
  id: string;
  type: string;
  isPaused: boolean;
  links: DefiItemActionData[];
};

const Actions = ({ id, type, links, isPaused }: Props) => {
  const { firebaseEventsData } = useStakeProvider();

  const getButtonProps = useCallback(
    (buttonVariant: DefiItemActionButtonType) => {
      if (buttonVariant === DefiItemActionButtonType.PRIMARY) {
        return {
          bg: "primary",
          color: "white",
          _dark: {
            bg: "white",
            color: "black",
          },
        };
      } else if (buttonVariant === DefiItemActionButtonType.SECONDARY) {
        return {
          variant: "outline",
          color: "textPrimary",
          borderColor: "#EEEEEF",
        };
      }
    },
    []
  );

  if (isPaused) {
    return (
      <Flex
        gap="4"
        justify={{ base: "center", lg: "flex-end" }}
        flex="1"
        align="center"
      >
        <Badge
          _dark={{
            bg: "textSecondary",
            color: "black",
          }}
        >
          Paused
        </Badge>
      </Flex>
    );
  }

  return (
    <Flex
      gap="4"
      justify={{ base: "center", lg: "flex-end" }}
      flex="1"
      align="center"
      onClick={(e) => {
        trackEvent(CLICK_DEFI_PARTNER_LINK, {
          defi_cta: (e.target as any).textContent,
          defi_name: id,
          type: type,
          ...firebaseEventsData,
        });
      }}
    >
      {links?.length > 0 ? (
        <>
          {links.map((item) => (
            <Button
              href={item.actionLink}
              key={item.actionCta}
              {...getButtonProps(item.buttonType)}
            >
              {item.actionCta}
            </Button>
          ))}
        </>
      ) : (
        <Badge
          _dark={{
            bg: "textSecondary",
            color: "black",
          }}
        >
          Coming soon
        </Badge>
      )}
    </Flex>
  );
};

export default Actions;
